var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-card',{staticClass:"chart-widget",attrs:{"title":_vm.$t('Instaviral')}},[_c('div',{staticClass:"flex xs12 md4 tiktok-statistics"},[_c('va-date-picker',{attrs:{"label":_vm.$t('forms.dateTimePicker.range'),"config":{ mode: 'range', dateFormat: 'Y-m-d' }},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})],1),_c('va-chart',{style:({ height: '500px' }),attrs:{"data":_vm.requestsStatistics,"type":"line"}}),_c('div',{staticClass:"flex xs12 md3"},[_c('va-select',{attrs:{"label":'Limit',"options":[
        '10',
        '20',
        '40',
        '80',
        '100',
        '200',
        '300',
        '400',
        '500',
        '1000' ],"noClear":""},model:{value:(_vm.limit),callback:function ($$v) {_vm.limit=$$v},expression:"limit"}})],1),_c('va-data-table',{attrs:{"fields":_vm.fields,"data":_vm.requests,"per-page":parseInt(_vm.limit)},scopedSlots:_vm._u([{key:"status",fn:function(props){return [_c('span',{class:{
          success: props.rowData.success,
          error: !props.rowData.success,
        }},[_vm._v(" "+_vm._s(props.rowData.success ? 'SUCCESS' : 'ERROR')+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }